import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { api } from "./config";

// Static translation files
import translationENG from "./locales/en.json";
import translationAR from "./locales/ar.json";

// Optional: Keep other locales here if you want to use local resources
const staticResources = {
  en: { translation: translationENG },
  ar: { translation: translationAR },
};

const language = localStorage.getItem("I18N_LANGUAGE") || "ar";
localStorage.setItem("I18N_LANGUAGE", language);
localStorage.setItem("langId", language === 'en'? 1 : 2)

// Initialize i18n
i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    lng: language,
    fallbackLng: "en",
    // resources: staticResources, // Optional: if using static
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    updateTranslations(language);
  });

// Convert API data to i18next format
const convertToI18nextFormat = (translations) => {
  return translations.reduce((acc, curr) => {
    acc[curr.LabelKey] = curr.Value;
    return acc;
  }, {});
};

// Fetch dynamic translations from API
const fetchTranslations = async (language) => {
  let result = await fetch(
    `${api.API_URL}/GetTranslations?language=${language}`,
    { headers: { environment: 'Prod' } }
  );
  result = await result.json();

  const data = convertToI18nextFormat(result.data);
  // console.log(`Fetched translations for ${language}:`, data);
  
  i18n.addResourceBundle(language, "translation", data, true, true);
   return data
};

export const updateTranslations = async (language) => {
  const data = await fetchTranslations(language);

  if (data) {
    i18n.addResourceBundle(language, "translation", data, true, true);
  }

  await i18n.changeLanguage(language);

  const newDir = i18n.dir(language);
  document.body.dir = newDir;

};


export default i18n;
